export class MealItemEntity {
  id?: string
  branchId?: number
  branchName?: string | null
  itemId?: number
  itemName?: string | null
  itemIsAvailable?: boolean
  notAvailableUntil?: string
  itemDisabled?: boolean
  user?: {
    id?: string
    displayName?: string | null
    phoneNumber?: string | null
  }
  unitPrice?: number
  selectionAdditionalPrice?: number
  rawPrice?: number
  quantity?: number
  createdAt?: string
}
